import { render, staticRenderFns } from "./ProcurementReportLabaRugi.vue?vue&type=template&id=fff1199e&"
import script from "./ProcurementReportLabaRugi.vue?vue&type=script&lang=js&"
export * from "./ProcurementReportLabaRugi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports